import { useAppContext, withLoading, createDateObject } from '@front-activerse/common-components';
import { Link } from 'react-router-dom';
import { PATH_DAY_PLAN_INDEX } from '../../MealPlanPaths';
import Timeline from '../../../Timeline';
import TimelinePlaceholder from '../../../Timeline/TimelinePlaceholder';

const DayPlanTimeline = ({ date, availableDays, additionalDatesCount = 14 }) => {
  const {
    svgInline: { LeftArrow, RightArrow },
  } = useAppContext();

  const getDates = () => {
    const values = availableDays.map((day) => createDateObject(day.date));

    if (values.length !== 0) {
      const lastDateValue = values[values.length - 1].valueOf();

      for (let idx = 1; idx <= additionalDatesCount; idx += 1) {
        const date = new Date(lastDateValue);
        date.setDate(date.getDate() + idx);
        values.push(date);
      }
    }

    return values;
  };

  const renderPhase = (isodate) => {
    const phaseDay = availableDays.find((day) => day.date === isodate);
    if (phaseDay) {
      return phaseDay.dayPlan.diet.phase.identifier.toLowerCase();
    }

    return '';
  };

  return (
    <div className="timeline-container">
      <Timeline
        activeDate={date}
        dates={getDates()}
        leftArrow={<LeftArrow />}
        rightArrow={<RightArrow />}
      >
        {({ active, isoDate, formattedDate, linkClassName }) => (
          <Link
            {...(active ? { 'aria-current': 'page' } : {})}
            to={`${PATH_DAY_PLAN_INDEX}/${isoDate}`}
            replace={true}
            className={`${linkClassName} ${renderPhase(isoDate)}`}
          >
            {formattedDate}
          </Link>
        )}
      </Timeline>
    </div>
  );
};

const Placeholder = () => {
  const {
    svgInline: { LeftArrow, RightArrow },
  } = useAppContext();
  return <TimelinePlaceholder leftArrow={<LeftArrow />} rightArrow={<RightArrow />} />;
};

export default withLoading(DayPlanTimeline, Placeholder);
